import { NavArrowDown } from 'iconoir-react';
import React, { FunctionComponent } from 'react';

import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import { Button } from '@savgroup-front-common/primitive/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@savgroup-front-common/primitive/ui/dropdown-menu';

import { CreateButtonMenuItem } from './CreateButtonMenuItem/CreateButtonMenuItem';
import CreateModal from './CreateModal';
import useCreateButton from './hooks/useCreateButton';
import messages from './messages';

const CreateButton: FunctionComponent = () => {
  const {
    onCreateModalClose,
    onMenuOpenChange,
    isMenuOpen,
    modalType,
    handleButtonClick,
    authorizedOptions,
    hasMultipleOptions,
    isDisabled,
    isOnlySparePartRequest,
  } = useCreateButton();

  const buttonLabel = isOnlySparePartRequest
    ? messages.sparePartRequest
    : messages.createLabel;

  return (
    <>
      {hasMultipleOptions && (
        <DropdownMenu open={isMenuOpen} onOpenChange={onMenuOpenChange}>
          <DropdownMenuTrigger asChild>
            <Button
              size="sm"
              data-testid="createButton"
              disabled={isDisabled}
              className="group gap-1.5 px-3.5"
            >
              <SafeFormattedMessageWithoutSpread message={buttonLabel} />
              {!isDisabled && (
                <NavArrowDown className="transition-transform group-data-[state=open]:rotate-180" />
              )}
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            align="end"
            data-testid="createButtonMenu"
            className="w-64"
          >
            {authorizedOptions.map((item) => (
              <CreateButtonMenuItem key={item.key} item={item} />
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      )}

      {!hasMultipleOptions && (
        <Button
          size="sm"
          data-testid="createButton"
          disabled={isDisabled}
          onClick={isDisabled ? undefined : handleButtonClick}
          className="gap-1.5 px-3.5"
        >
          <SafeFormattedMessageWithoutSpread message={buttonLabel} />
        </Button>
      )}

      <CreateModal onClose={onCreateModalClose} modalType={modalType} />
    </>
  );
};

export default React.memo(CreateButton);
